import { useAuth0 } from "@auth0/auth0-react";

const LogoutButton = () => {
  const { logout } = useAuth0();

  return (
    <a href="#" onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}>
      Sair
    </a>
  );
};

export default LogoutButton;